import { useInView } from '../../../hooks/useInView';

const clients = [
  { name: "McDonald's", tag: "National Brand", icon: 'ri-store-2-fill' },
  { name: "The Walt Disney Co.", tag: "Entertainment", icon: 'ri-film-fill' },
  { name: "ABC Network", tag: "Broadcast Television", icon: 'ri-broadcast-fill' },
  { name: "FOX News", tag: "National Media", icon: 'ri-tv-2-fill' },
  { name: "Hewlett-Packard", tag: "Technology", icon: 'ri-computer-fill' },
  { name: "U.S. GSA", tag: "Federal Government", icon: 'ri-government-fill' },
  { name: "Spectrum", tag: "Telecommunications", icon: 'ri-wifi-fill' },
  { name: "McDonald's", tag: "National Brand", icon: 'ri-store-2-fill' },
  { name: "The Walt Disney Co.", tag: "Entertainment", icon: 'ri-film-fill' },
  { name: "ABC Network", tag: "Broadcast Television", icon: 'ri-broadcast-fill' },
  { name: "FOX News", tag: "National Media", icon: 'ri-tv-2-fill' },
  { name: "Hewlett-Packard", tag: "Technology", icon: 'ri-computer-fill' },
  { name: "U.S. GSA", tag: "Federal Government", icon: 'ri-government-fill' },
  { name: "Spectrum", tag: "Telecommunications", icon: 'ri-wifi-fill' },
];

const stats = [
  { num: '20+', label: 'Years of Excellence', icon: 'ri-award-fill' },
  { num: '500+', label: 'Productions Delivered', icon: 'ri-movie-2-fill' },
  { num: '2', label: 'Languages Spoken', icon: 'ri-global-line' },
  { num: '100%', label: 'Client Satisfaction', icon: 'ri-star-fill' },
];

export default function TrustBar() {
  const { ref, inView } = useInView();

  return (
    <section className="bg-[#080808] border-y border-white/5 overflow-hidden relative">
      {/* Top label */}
      <div
        ref={ref as React.RefObject<HTMLDivElement>}
        className={`py-10 text-center transition-all duration-700 ${inView ? 'opacity-100' : 'opacity-0'}`}
      >
        <div className="flex items-center justify-center gap-6 mb-2">
          <div className="w-20 h-px bg-gradient-to-r from-transparent to-gold/40" />
          <span className="font-sans text-[0.58rem] tracking-[0.45em] uppercase text-gold/70 font-medium">
            Trusted by Brands, Broadcasters &amp; Government Organizations
          </span>
          <div className="w-20 h-px bg-gradient-to-l from-transparent to-gold/40" />
        </div>
        <p className="font-sans text-[0.58rem] tracking-[0.2em] uppercase text-white/20">
          20+ Years of Broadcast-Level Production Excellence in Central Florida
        </p>
      </div>

      {/* Marquee row */}
      <div className="relative pb-10 overflow-hidden">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#080808] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#080808] to-transparent z-10 pointer-events-none" />
        <div className="flex overflow-hidden">
          <div className="flex items-center gap-16 animate-marquee whitespace-nowrap">
            {clients.map((c, i) => (
              <div key={i} className="flex items-center gap-4 flex-shrink-0 group cursor-default">
                <div className="w-8 h-8 flex items-center justify-center border border-gold/15 group-hover:border-gold/40 transition-colors duration-400">
                  <i className={`${c.icon} text-gold/40 group-hover:text-gold/70 text-sm transition-colors duration-400`} />
                </div>
                <div className="flex flex-col">
                  <span className="font-serif text-lg font-bold text-white/25 group-hover:text-white/55 transition-colors duration-500 tracking-wide leading-none">
                    {c.name}
                  </span>
                  <span className="font-sans text-[0.52rem] tracking-[0.25em] uppercase text-gold/25 group-hover:text-gold/50 transition-colors duration-500 mt-0.5">
                    {c.tag}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Stats bar */}
      <div
        className={`border-t border-white/5 transition-all duration-700 delay-200 ${inView ? 'opacity-100' : 'opacity-0'}`}
      >
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4">
          {stats.map(({ num, label, icon }, i) => (
            <div
              key={label}
              className={`flex flex-col items-center justify-center py-10 gap-3 group cursor-default ${i < stats.length - 1 ? 'border-r border-white/5' : ''}`}
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className={`${icon} text-gold/50 group-hover:text-gold text-lg transition-colors duration-300`} />
              </div>
              <p className="font-serif text-3xl font-bold text-gold leading-none">{num}</p>
              <p className="font-sans text-[0.57rem] tracking-[0.22em] uppercase text-white/35 text-center leading-snug">{label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
